import React from 'react';
import styles from './Logout.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { logoutUser } from '../../../../../store/actions/auth';
import ModalIcon from '../../Icon/Icon';
import { getTranslation } from '../../../../../utils/translation';
import Title from '../../Title/Title';
import Button from '../../Button/Button';
import InfoMessage from '../../InfoMessage/InfoMessage';

const Logout = withRouter(({ history, ...props }) => {
    const dispatch = useDispatch();

    const onLogoutUser = () => {
        dispatch(logoutUser());
    };

    const { requestLogout } = useSelector(state => state.auth);

    return (
        <>
            <ModalIcon iconKey='logout' />
            <Title>{getTranslation('logoutModalTitle')}</Title>
            <InfoMessage width='140px'>{getTranslation('logoutModalContent')}</InfoMessage>
            <div className={styles.actionWrapper}>
                <Button
                    onClick={onLogoutUser}
                    disabled={requestLogout}
                    width='137px'
                    title={getTranslation('logoutModalYesButton')}
                />
                <Button
                    secondary
                    onClick={props.closeModal}
                    width='137px'
                    title={getTranslation('logoutModalNoButton')}
                />
            </div>
        </>
    );
});

export default Logout;
